export default {
  ALERT: 'ALERT',
  CONFIRM: 'CONFIRM'
}